import React, { useCallback } from 'react';

import ModalFooterButton from 'components/Modal/ModalFooterButton';
import { Handle } from 'components/SocialAccountInfo';
import { Step } from 'components/SteppedModal';
import SwitchAccountMessage from 'components/SwitchAccountMessage';
import useTwitterAuthenticator, {
  UseTwitterAuthenticatorConfig,
} from 'hooks/useTwitterAuthenticator';
import useTwitterPostModalSelector from '../useTwitterPostModalSelector';
import { TwitterPostModalSteps } from './types';

export interface UseSwitchAccountStepConfig
  extends Partial<Pick<UseTwitterAuthenticatorConfig, 'onError'>> {
  onSwitchAccount?: () => void;
  onSwitchAccountSuccess?: () => void;
}

export default function useSwitchAccountStep(
  config: UseSwitchAccountStepConfig = {},
): Step<TwitterPostModalSteps> {
  const { onSwitchAccount, onSwitchAccountSuccess, onError } = config;
  const { username } = useTwitterPostModalSelector();

  const { authenticate, authenticating } = useTwitterAuthenticator({
    force: true,
    onAuthSuccess: onSwitchAccountSuccess,
    onError,
  });

  const handleAuthenticate = useCallback((): void => {
    onSwitchAccount();
    authenticate();
  }, [authenticate, onSwitchAccount]);

  return {
    id: 'switch',
    title: 'switch x accounts',
    component: (
      <SwitchAccountMessage username={<Handle username={username} />} />
    ),
    renderFooterButtons: ({ cancel, submit }) => [
      <ModalFooterButton {...cancel} key="cancel">
        cancel
      </ModalFooterButton>,

      <ModalFooterButton
        {...submit}
        key="submit"
        theme="submit"
        disabled={authenticating}
        onClick={handleAuthenticate}
      >
        switch accounts
      </ModalFooterButton>,
    ],
  };
}
